
import React, { Component } from 'react';
import { render } from 'react-dom';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import DialogContentAddKatuze from './DialogContentAddKatuze';

let resolve;

class DialogAddKatuze extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogAddKatuze />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            color: '',
            title: ''
        };
    }

    checkValues() {
        let warnings = [];
        return (warnings.length === 0);
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleConfirm = () => {
        if (this.checkValues()) {
            this.setState({hidden: true});
            resolve({
                selectedKatuzeItems: this.state.selectedKatuzeItems
            });
        }
    }

    handleChange = (selectedKatuzeItems) => {
        this.setState({selectedKatuzeItems: selectedKatuzeItems});
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Přidat katastrální území do projektu"
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                    <DialogContentAddKatuze
                        katuzeItems={this.state.katuzeItems}
                        onChange={this.handleChange}
                    />
                <DialogFooter>
                    <PrimaryButton onClick={this.handleConfirm} text="Přidat" />
                    <DefaultButton onClick={this.handleCancel} text="Zrušit" />
                </DialogFooter>
            </Dialog>
        );
    }

    show(katuzeItems) {
        this.setState({
            hidden: false,
            katuzeItems: katuzeItems,
            selectedKatuzeItems: []
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogAddKatuze.create();
